module.exports = __webpack_public_path__ + "static/media/birth-spacing@2x.95e72c8b.png";